<template>
  <v-app>
    <v-app-bar app flat>
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="light-blue lighten-3 pt-14">
      <v-container fill-height fluid class="account-bg">
        <v-row align="center">
          <v-col cols="12" md="8" offset-md="2">
            <RegisterComponent :data="data" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import RegisterComponent from "@/components/user/RegisterComponent.vue";

export default {
  name: "Register",
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    RegisterComponent
  },
  data() {
    return {
      data: {
        fname: "",
        lname: "",
        email: "",
        phone: "",
        password: "",
        cpassword: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        postalcode: "",
        country: "",
        primary_country: "",
        airbnbId: "",
        profilePic: "",
        terms: false,
        prefered_currency: this.$store.state.user.prefered_currency
      }
    };
  },
  methods: {}
};
</script>

<style scoped>
.account-bg {
  background-image: url("~@/assets/images/bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
